import { ReactNode } from 'react';
import { ArrowRightIcon } from '../common/Icons';

const widthMap = {
  xs: 'max-w-xs',
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
} as const;

export type ClerkWrapperWidth = keyof typeof widthMap;

type ClerkWrapperProps = {
  children: ReactNode;
  width?: ClerkWrapperWidth;
  onBack?: () => void;
};

export function ClerkWrapper({ children, width = 'xl', onBack }: ClerkWrapperProps) {
  return (
    <div
      className={`${widthMap[width]} relative w-full rounded-[0.75rem] border border-[rgba(0,0,0,0.07)] bg-white py-8 shadow-[0_5px_15px_0_rgba(0,0,0,0.08),0_15px_35px_-5px_rgba(0,0,0,0.2),0_0_0_1px_rgba(0,0,0,0.07)]`}
    >
      {onBack && (
        <button
          onClick={onBack}
          className='absolute left-4 top-4 flex items-center justify-center cursor-pointer bg-transparent border-none p-2 hover:opacity-70 transition-opacity text-gray-900 z-10'
          aria-label='Back'
        >
          <ArrowRightIcon className='rotate-180' width='20' height='20' />
        </button>
      )}
      <div className='mx-auto flex w-full max-w-3xl flex-col items-center justify-center px-4'>{children}</div>
    </div>
  );
}
